import React, { useContext, useEffect, useRef } from 'react';
import { isEmpty } from "lodash";
import cn from 'classnames';
import { selectGroup, IndexData } from "../../../common/index-context";
import TableFivePointsScales from "../../../common/components/entity-modal/table-five-points-scales";
import TableAttributeRatings from "../../../common/components/entity-modal/table-attribute-ratings";
import TablePreference from "../../../common/components/entity-modal/table-preference";
import ComparisonsLegend from "../../../common/components/comparisons-legend";
import TableCustomMetrics from "../../../common/components/entity-modal/table-custom_metrics";

const TableConcept = ({ data, current }) => {
  const fivePointScales = selectGroup(data, 'five_point_scale');
  const fivePointScalesPresent = !isEmpty(fivePointScales);

  const customMetrics = selectGroup(data, 'custom_metric');
  const customMetricsPresent = !isEmpty(customMetrics);

  const attributeRatings1 = selectGroup(data, 'adcept_attribute_ratings1');
  const attributeRatings1Present = !isEmpty(attributeRatings1);
  const attributeRatings2 = selectGroup(data, 'adcept_attribute_ratings2');
  const attributeRatings2Present = !isEmpty(attributeRatings2);

  const preference = selectGroup(data, 'preference');
  const preferencePresent = !isEmpty(preference);

  const fpAcstAp = fivePointScalesPresent || customMetricsPresent || preferencePresent;
  const ar1Aar2 = attributeRatings1Present || attributeRatings2Present;

  const tourElement = useRef(null);
  const { getTourUseEffectArgs, averageMode } = useContext(IndexData);
  const [ callback, condition ] = getTourUseEffectArgs(
    "projectModalTable",
    tourElement
  );
  useEffect(callback, condition);

  return (
    <>
      <div
        className="concept-report_tables comparisons_grid"
        ref={ tourElement }
      >
        {
          fpAcstAp &&
          <>
            <div className="comparisons_col -grow">
              {
                fivePointScalesPresent &&
                <TableFivePointsScales
                  data={ data }
                  current={ current }
                  fivePointScales={ fivePointScales }
                  groupName="five_point_scale"
                  className="-long-first-cell"
                />
              }
              {
                customMetricsPresent &&
                <TableCustomMetrics
                  data={ data }
                  current={ current }
                  customMetrics={ customMetrics }
                  groupName="custom_metrics"
                  className="-long-first-cell"
                />
              }
              {
                preferencePresent &&
                <TablePreference
                  data={ data }
                  current={ current }
                  preference={ preference }
                />
              }
            </div>
          </>
        }

        {
          ar1Aar2 &&
          <div
            className={
              cn(
                "comparisons_col",
                {
                  '-grow': !fpAcstAp,
                  '-width-50': fpAcstAp
                })
            }
          >
            {
              attributeRatings1Present &&
              <TableAttributeRatings
                data={ data }
                current={ current }
                attributeRatings={ attributeRatings1 }
                groupName="adcept_attribute_ratings1"
              />
            }
            {
              attributeRatings2Present &&
              <TableAttributeRatings
                className="js-ar2"
                data={ data }
                current={ current }
                attributeRatings={ attributeRatings2 }
                groupName="adcept_attribute_ratings2"
              />
            }
          </div>
        }
      </div>
      <ComparisonsLegend
        forModal
        averageMode={ averageMode }
        statTesting={ data.stat_testing }
      />
    </>
  );
};

export default TableConcept;
